// extracted by mini-css-extract-plugin
export default {"feature-card":"FeatureCard_feature-card__gPcS8","icon":"FeatureCard_icon__WKNif","title":"FeatureCard_title__ONXpt","description":"FeatureCard_description__Ey20f"};